import http, { endpoints, HEADER_USER_ID_KEY } from '../http';
import { persistLoginSettings } from '../../efkt/auth/storage';
import { mapUserFromDto } from '../users/helpers';
import { LocalizedError } from '@libs/localization';
import decode from 'jwt-decode';
const datahubClient = http.createClient(`${endpoints.datahub}`);
export default class AuthApi {
    static isAuthenticated() {
        return !!http.getAuthToken();
    }
    static deauthenticate() {
        http.forgetAuthToken();
    }
    static getUserFromToken() {
        const token = http.getAuthToken();
        return token && decode(token);
    }
    static async getAuthenticatedUser() {
        var _a;
        const token = http.getAuthToken();
        if (!token) {
            return undefined;
        }
        const authUserResponse = await datahubClient.get('/Authentication/user');
        const authUser = authUserResponse === null || authUserResponse === void 0 ? void 0 : authUserResponse.data;
        if (!(authUser === null || authUser === void 0 ? void 0 : authUser.email)) {
            throw new LocalizedError('auth.pages.activeDirectory.errorGettingUser');
        }
        const branchesResponse = await datahubClient.get('/Authentication/user/branches');
        const detailedBranches = (branchesResponse === null || branchesResponse === void 0 ? void 0 : branchesResponse.data) || [];
        const userResponse = await datahubClient.get(`/User/id/${authUser.currentlyImpersonatingUserId || authUser.id}`);
        const user = userResponse === null || userResponse === void 0 ? void 0 : userResponse.data;
        const resultBranches = ((_a = user === null || user === void 0 ? void 0 : user.branches) === null || _a === void 0 ? void 0 : _a.map(branch => {
            const foundDetailedBranch = detailedBranches.find(detailedBranch => detailedBranch.id === branch.id);
            if (foundDetailedBranch) {
                return {
                    ...foundDetailedBranch,
                    ...branch,
                    country: branch.countryCode || branch.country || foundDetailedBranch.country,
                };
            }
            return branch;
        })) || [];
        return mapUserFromDto({ ...authUser, settings: user.settings }, resultBranches);
    }
    static async getShineToken() {
        const token = http.getAuthToken();
        const dto = {
            TokenValue: token || '',
            HashValue: '',
        };
        return dto;
    }
    static async b2cAuth(email, appRoute) {
        const response = await datahubClient.get(`/Authentication/login-url?redirectUrl=${`${window.location.origin}${appRoute}`}&email=${email}&nonce=esoft-test`);
        const data = response === null || response === void 0 ? void 0 : response.data;
        // Shared with `efkt/auth`, so a session started against either backend leaves the same state
        // behind and nothing downstream has to know which one answered.
        persistLoginSettings(data, { email, viaAdJourney: false });
        return data;
    }
    static async esoftAuth(appRoute) {
        const response = await datahubClient.get(`/Authentication/login-esoft-url?redirectUrl=${`${window.location.origin}${appRoute}`}&nonce=esoft-test`);
        const data = response === null || response === void 0 ? void 0 : response.data;
        persistLoginSettings(data, { viaAdJourney: true });
        return data;
    }
    static persistToken(token) {
        http.setAuthToken(token, false);
    }
    static clearAuthHeaders() {
        try {
            const userIdHeader = JSON.parse(localStorage.getItem(HEADER_USER_ID_KEY) || '');
            (userIdHeader === null || userIdHeader === void 0 ? void 0 : userIdHeader.value) && localStorage.setItem(HEADER_USER_ID_KEY, JSON.stringify({ header: userIdHeader.header }));
        }
        catch (ex) {
            // noop
        }
    }
}
